import React from 'react';
import CalendarAddOn from '#components/icons/CalendarAddOn';
import IconButton from '#components/controls/icon-button/IconButton';

type Props = {
  downloadUrl: string;
};

const CalendarButton = ({ downloadUrl }: Props) => {
  const handleClick = (event: React.MouseEvent) => {
    event.preventDefault();
    window.location.href = downloadUrl;
  };

  return (
    <IconButton
      onClick={handleClick}
      size="large"
      variant="outlined"
      color="primary"
    >
      <CalendarAddOn />
    </IconButton>
  );
};

export default CalendarButton;
